var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataList',{attrs:{"title":"Категорії продуктів","resource":"product-categories","columns":_vm.columns,"get-items-fn":_vm.getProductCategories,"search-label":'Пошук за назвою категорії продукта'}})}
var staticRenderFns = []

export { render, staticRenderFns }